import infoHeader from './infoHeader.vue'
export default infoHeader